import { t } from "@lingui/macro";

import { ErrorIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { Box, Text } from "@whoosh/design-system/src/components/primitive";

export const EventListEmptyState = () => {
  return (
    <Box
      justifyContent="center"
      alignItems="center"
      height={{ base: 68, md: 123 }}
    >
      <ErrorIcon />
      <Text variant="mainBaseMedium" mt={4}>
        {t`There are no events at this moment.`}
      </Text>
    </Box>
  );
};
